/**
 *
 * Asynchronously loads the component for TeammatesPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const TeammatesPage = lazyLoad(
  () => import('./index'),
  module => module.TeammatesPage,
);
